/** Route paths for the rewards admin module. */
export const RewardsRoutes = {
  DASHBOARD: "/rewards",
  PROGRAMS: "/rewards/programs",
  PROGRAM_NEW: "/rewards/programs/new",
  PROGRAM_EDIT: "/rewards/programs/:id",
  TIERS: "/rewards/tiers",
  RULES: "/rewards/rules",
  RULE_NEW: "/rewards/rules/new",
  RULE_EDIT: "/rewards/rules/:id",
  SIMULATOR: "/rewards/simulator",
  MEMBERS: "/rewards/members",
  MEMBER_DETAIL: "/rewards/members/:id",
  CATALOG: "/rewards/catalog",
  CATALOG_NEW: "/rewards/catalog/new",
  CATALOG_EDIT: "/rewards/catalog/:id",
  REDEMPTIONS: "/rewards/redemptions",
  AUDIT: "/rewards/audit",
} as const;

/** Builds a concrete path from a parameterized route. */
export function rewardsPath(route: string, params: Record<string, string>): string {
  return Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, value),
    route,
  );
}
